import { render, staticRenderFns } from "./CanteenMenuSheet.vue?vue&type=template&id=7912294a"
import script from "./CanteenMenuSheet.vue?vue&type=script&lang=js"
export * from "./CanteenMenuSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports